import React from "react";

/**
 * @param {object} props
 * @param {Array<{ id: string, label: string, icon?: string, onClick?: () => void, href?: string, to?: string }>} props.actions
 * @param {(action: object) => React.ReactNode} [props.renderAction]
 * @param {string} [props.testId]
 */
export function GsdQuickActions({ actions = [], renderAction, testId = "gsd-quick-actions" }) {
  if (!actions.length) return null;
  return (
    <div className="gsd-quick-actions" data-testid={testId}>
      {actions.map((action) => {
        if (renderAction) return <React.Fragment key={action.id}>{renderAction(action)}</React.Fragment>;
        if (action.onClick) {
          return (
            <button key={action.id} type="button" className="gsd-quick-actions__btn" onClick={action.onClick}>
              {action.icon ? <span aria-hidden="true">{action.icon}</span> : null}
              {action.label}
            </button>
          );
        }
        return (
          <a key={action.id} href={action.to || action.href || "#"} className="gsd-quick-actions__btn">
            {action.icon ? <span aria-hidden="true">{action.icon}</span> : null}
            {action.label}
          </a>
        );
      })}
    </div>
  );
}

/**
 * @param {object} props
 * @param {Array<{ id: string, label: string, value: string|number, hint?: string, icon?: string }>} props.items
 * @param {string} [props.testId]
 */
export function GsdStatGrid({ items = [], testId = "gsd-stat-grid" }) {
  return (
    <div className="gsd-stat-grid" data-testid={testId}>
      {items.map((item) => (
        <div key={item.id} className="gsd-stat-grid__tile" data-testid={`gsd-stat-${item.id}`}>
          {item.icon ? <span className="gsd-stat-grid__icon" aria-hidden="true">{item.icon}</span> : null}
          <span className="gsd-stat-grid__value">{item.value}</span>
          <span className="gsd-stat-grid__label">{item.label}</span>
          {item.hint ? <span className="gsd-stat-grid__hint">{item.hint}</span> : null}
        </div>
      ))}
    </div>
  );
}
